import request from '@/utils/httpRequest'
import { data } from 'jquery'

export function projectInfo(pid) {
    return request({
        url: '/app/index/infoName/' + pid,
        method: 'get'
    })
}

export function projectList(data) {
    return request({
        url: '/app/business/projectsupervisorinfo/list',
        method: 'get',
        params: data
    })
}

export function projectInfoCount(workNo) {
    return request({
        url: '/app/business/projectsupervisorinfo/infoCount/' + workNo,
        method: 'get'
    })
}

export function syslogin(data) {
    return request({
        url: '/app/sys/loginByOa',
        method: 'post',
        data
    })
}

